// import {
//   GetAllCurricularUnitsUserUseCaseInterface,
//   GetAllGroupsUserUseCaseInterface,
//   GetInternshipLocationUseCaseInterface,
// } from 'domain/usecases';
import {
  convertEventSelectToTarget,
  formatDataToLabelValue,
  FormFeedBack,
  Select,
} from '@repo/ui';
import { FormikValues } from 'formik';
import { notifyError } from 'presentation/app/components/notify';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  loadCoursesUser,
  setLoadingCoursesUser,
} from 'presentation/config/store/courses/courses-slice';
// import {
//   loadCurricularUnitsUser,
//   setLoadingCurricularUnitsUser,
// } from 'presentation/config/store/curricular-units/curricular-units-slice';
// import {
//   loadGroupsUser,
//   setLoadingGroupsUser,
// } from 'presentation/config/store/groups/groups-slice';
// import { loadInternshipLocation } from 'presentation/config/store/internship-location/internship-location-slice';
import {
  loadOrganizationsUser,
  setLoadingOrganizationsUser,
} from 'presentation/config/store/organizations/organizations-slice';
import {
  loadSemestersUser,
  setLoadingSemestersUser,
} from 'presentation/config/store/semesters/semesters-slice';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CardBody, Col, Form, Label, Row } from 'reactstrap';

interface IProps {
  validation: FormikValues;
}

export const StudentsFilters = ({ validation }: IProps) => {
  // Hooks
  const service = useService();
  const dispatch = useDispatch();
  const { currentUser } = useAuth();

  const {
    // groupService,
    courseService,
    semesterService,
    organizationService,
    // curricularUnitService,
  } = service;

  const { organizationsUser, loadingOrganizationsUser } = useAppSelector(
    (state) => state.organizations,
  );
  const { coursesUser, loadingCoursesUser } = useAppSelector(
    (state) => state.courses,
  );
  const { semestersUser, loadingSemestersUser } = useAppSelector(
    (state) => state.semesters,
  );
  // const { curricularUnitsUser, loadingCurricularUnitsUser } = useAppSelector(
  //   (state) => state.curricularUnits,
  // );
  // const { groupsUser, loadingGroupsUser } = useAppSelector(
  //   (state) => state.groups,
  // );

  // const { data: internshipLocationOptions } = useAppSelector(
  //   (state) => state.internshipLocation,
  // );

  const { filterBySemester } = currentUser;

  // Methods
  const requestGetAllOrganizationsUser = useCallback(async () => {
    dispatch(setLoadingOrganizationsUser(true));
    await organizationService
      .getAllOrganizationsUser()
      .then((res) => dispatch(loadOrganizationsUser(res)))
      .catch((err) => {
        dispatch(setLoadingOrganizationsUser(false));
        notifyError(err.message);
      })
      .finally(() => dispatch(setLoadingOrganizationsUser(false)));
  }, []);

  const requestGetAllCoursesUser = useCallback(async (entityId?: string) => {
    dispatch(setLoadingCoursesUser(true));
    await courseService
      .getAllCoursesUser({ entityId })
      .then((res) => dispatch(loadCoursesUser(res)))
      .catch((err) => {
        dispatch(setLoadingCoursesUser(false));
        notifyError(err.message);
      })
      .finally(() => dispatch(setLoadingCoursesUser(false)));
  }, []);

  const requestGetAllSemestersUser = useCallback(async (entityId: string) => {
    dispatch(setLoadingSemestersUser(true));
    await semesterService
      .getAllSemestersUser({ entityId })
      .then((res) => dispatch(loadSemestersUser(res)))
      .catch((err) => {
        notifyError(err.message);
        dispatch(setLoadingSemestersUser(false));
      })
      .finally(() => dispatch(setLoadingSemestersUser(false)));
  }, []);

  // const requestGetAllCurricularUnitsUser = useCallback(
  //   async (params: GetAllCurricularUnitsUserUseCaseInterface.Params) => {
  //     dispatch(setLoadingCurricularUnitsUser(true));
  //     await curricularUnitService
  //       .getAllCurricularUnitsUser(params)
  //       .then((res) => dispatch(loadCurricularUnitsUser(res)))
  //       .catch((err) => {
  //         notifyError(err.message);
  //         dispatch(setLoadingCurricularUnitsUser(false));
  //       })
  //       .finally(() => dispatch(setLoadingCurricularUnitsUser(false)));
  //   },
  //   [],
  // );

  // const requestGetAllGroupsUser = useCallback(
  //   async (params: GetAllGroupsUserUseCaseInterface.Params) => {
  //     dispatch(setLoadingGroupsUser(true));
  //     await groupService
  //       .getAllGroupsUser(params)
  //       .then((res) => dispatch(loadGroupsUser(res)))
  //       .catch((err) => {
  //         dispatch(setLoadingGroupsUser(false));
  //         notifyError(err.message);
  //       })
  //       .finally(() => dispatch(setLoadingGroupsUser(false)));
  //   },
  //   [],
  // );

  useEffect(() => {
    // useEffect responsible for the first filter calls
    requestGetAllOrganizationsUser();
    requestGetAllCoursesUser();
  }, []);

  // useEffect(() => {
  // useEffect responsible for resetting Curricular Units and Groups' selects' options
  // const selectedOrganization = validation.values.entity?.value;
  // const selectedCourse = validation.values.course?.value;

  // const selectedSemester = validation.values.semester?.value || '';
  // const selectedCurricularUnit =
  //   validation.values.curricularUnit?.value || '';

  // if (selectedOrganization && selectedCourse) {
  //   requestGetAllCurricularUnitsUser({
  //     entityId: selectedOrganization,
  //     courseId: selectedCourse,
  //   });
  // requestGetAllGroupsUser({
  //   courseId: selectedCourse,
  //   semesterId: selectedSemester,
  //   entityId: selectedOrganization,
  //   curricularUnitId: selectedCurricularUnit,
  // });
  //   }
  // }, [
  //   validation.values.entity?.value,
  //   validation.values.course?.value,
  //   validation.values.semester?.value,
  //   validation.values.curricularUnit?.value,
  // ]);

  const optionsValuesInGroup = [
    {
      label: 'Apenas em grupos',
      value: 'true',
    },
    {
      label: 'Apenas sem grupos',
      value: 'false',
    },
  ];

  return (
    <Form
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      <CardBody>
        <Row>
          <>
            <Col lg={4} className="mb-3">
              <Label htmlFor="entity" className="form-label">
                Organização:
              </Label>
              <Select
                isClearable
                id="entity"
                name="entity"
                placeholder="Todas as Organizações"
                value={validation.values.entity}
                isLoading={loadingOrganizationsUser}
                onChange={(e) => {
                  if (!e) {
                    validation.resetForm();
                  }
                  requestGetAllCoursesUser(e?.value || '');
                  requestGetAllSemestersUser(e?.value || '');
                  validation.setValues({
                    ...validation.values,
                    course: null,
                    semester: null,
                    unit: null,
                    group: null,
                    local: null,
                  });

                  validation.handleChange(
                    convertEventSelectToTarget('entity', e),
                  );
                }}
                invalid={!!(validation.touched && validation.errors?.entity)}
                onBlur={validation.handleBlur}
                options={formatDataToLabelValue(
                  organizationsUser as never,
                  'id',
                  'nome',
                )}
              />
              <FormFeedBack
                error={validation.errors?.entity}
                isInvalid={!!(validation.touched && validation.errors?.entity)}
              />
            </Col>
            <Col lg={4} className="mb-3">
              <Label htmlFor="course" className="form-label">
                Curso:
              </Label>
              <Select
                isClearable
                id="course"
                name="course"
                placeholder="Todos os Cursos"
                value={validation.values.course}
                isLoading={loadingCoursesUser}
                onChange={(e) => {
                  if (!e) {
                    validation.resetForm();
                  }

                  validation.handleChange(
                    convertEventSelectToTarget('course', e),
                  );
                }}
                onBlur={validation.handleBlur}
                options={formatDataToLabelValue(
                  coursesUser as never,
                  'id',
                  'nome',
                )}
              />
            </Col>
          </>

          {/* {filterByCurricularUnit && (
            <Col lg={filterByEntityAndCourse ? 4 : 12} className="mb-3">
              <Label htmlFor="unit" className="form-label">
                Unidade Curricular:
              </Label>
              <Select
                isClearable
                id="curricularUnit"
                name="curricularUnit"
                placeholder="Todas as Unidades Curriculares"
                value={validation.values.curricularUnit}
                onChange={(e) => {
                  validation.handleChange(
                    convertEventSelectToTarget('curricularUnit', e),
                  );
                }}
                onBlur={validation.handleBlur}
                options={formatDataToLabelValue(
                  curricularUnitsUser as never,
                  'id',
                  'nome',
                )}
                isDisabled={
                  !(validation.values.entity && validation.values.course)
                }
              />
            </Col>
          )} */}

          {filterBySemester && (
            <Col lg={4} className="mb-3">
              <Label htmlFor="semester" className="form-label">
                Semestre:
              </Label>
              <Select
                isClearable
                id="semester"
                name="semester"
                placeholder="Todos os Semestres"
                value={validation.values.semester}
                isLoading={loadingSemestersUser}
                onChange={(e) => {
                  validation.handleChange(
                    convertEventSelectToTarget('semester', e),
                  );
                }}
                onBlur={validation.handleBlur}
                options={formatDataToLabelValue(
                  semestersUser as never,
                  'id',
                  'nome',
                )}
                isDisabled={!validation.values.entity}
              />
            </Col>
          )}
          <Col lg={4} className="mb-3">
            <Label htmlFor="semester" className="form-label">
              Associação a Grupos:
            </Label>
            <Select
              isClearable
              id="inGroup"
              name="inGroup"
              placeholder="Todos"
              value={validation?.values?.inGroup}
              isLoading={loadingSemestersUser}
              onChange={(e) => {
                validation.handleChange(
                  convertEventSelectToTarget('inGroup', e),
                );
              }}
              onBlur={validation.handleBlur}
              options={optionsValuesInGroup}
            />
          </Col>
          {/* <Col lg={filterBySemester ? 4 : 8} className="mb-3">
            <Label htmlFor="group" className="form-label">
              Grupo:
            </Label>
            <Select
              isClearable
              id="group"
              name="group"
              placeholder="Todos os Grupos"
              value={validation.values.group}
              onChange={(e) => {
                validation.handleChange(convertEventSelectToTarget('group', e));
              }}
              onBlur={validation.handleBlur}
              options={formatDataToLabelValue(
                groupsUser as never,
                'id',
                'nome',
              )}
              isDisabled={
                !(validation.values.entity && validation.values.course)
              }
            />
          </Col> */}
        </Row>
      </CardBody>
    </Form>
  );
};
